/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';

// i18n
import 'src/locales/i18n';
// eslint-disable-next-line import/no-extraneous-dependencies

// ----------------------------------------------------------------------

import Router from 'src/routes/sections';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import ThemeProvider from 'src/theme';
import { LocalizationProvider } from 'src/locales';

import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import { SettingsDrawer, SettingsProvider } from 'src/components/settings';

import { CheckoutProvider } from 'src/sections/checkout/context';

import { AuthProvider } from 'src/auth/context/auth0';
import LogRocket from 'logrocket';

// ----------------------------------------------------------------------

export default function App() {
  const charAt = `

  ░░░    ░░░
  ▒▒▒▒  ▒▒▒▒
  ▒▒ ▒▒▒▒ ▒▒
  ▓▓  ▓▓  ▓▓
  ██      ██

  `;

  // TODO: this if statement might always be true, I'd need more time to actually figure this out.
  // For now it's not the end of the world if it's always true, but we should probably fix this so that
  // we aren't spending money tracking development sessions.
  if(import.meta.env.VITE_PROFILE !== 'development') {
    LogRocket.init('mykvoh/unify-mental-health'); // TODO: put this back in when we want to turn on log rocket
  }

  console.info(`%c${charAt}`, 'color: #5BE49B');

  const consoleError = console.error; // Store the original function

  console.error = (...args) => {
    const findDOMNodeWarning = /findDOMNode is deprecated/;

    // If the warning text does not match the findDOMNodeWarning, don't suppress it
    if (args.some(item => findDOMNodeWarning.test(item))) {
      return;
    }

    consoleError(...args);
  };

  useScrollToTop();

  return (
    <AuthProvider>
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'cyan', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <CheckoutProvider>
                  <SettingsDrawer />
                  <ProgressBar />

                  <Router />
                </CheckoutProvider>
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </AuthProvider>
  );
}
